import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import {
  setIsDropdownOpen,
  setIsMobileViewActive,
  setMenuOpen,
} from "../../Redux/features/NavBar/MenuSlice";

/**
 * Fixed rail padding via CSS. Pin expands content with
 * `html[data-qv-sidebar-pinned="1"]` (set sync on toggle) — no Redux
 * subscription here, so the page tree does not re-render on pin.
 */
function MainContentOffset({ className, disabled, children }) {
  const dispatch = useDispatch();
  const isTabletNav = useMediaQuery("(max-width:1024px)");
  const isMobileNav = useMediaQuery("(min-width:767px)");

  const onClickHandler = useCallback(() => {
    if (isTabletNav) {
      dispatch(setMenuOpen(false));
      dispatch(setIsDropdownOpen(false));
      dispatch(setIsMobileViewActive(false));
    }
  }, [dispatch, isTabletNav]);

  if (disabled) {
    return (
      <div className={className} onClick={onClickHandler}>
        {children}
      </div>
    );
  }

  const offsetClass = !isMobileNav
    ? "qv-main-offset qv-main-offset--phone"
    : "qv-main-offset qv-main-offset--desktop";

  return (
    <div
      className={`${className} ${offsetClass}`.trim()}
      onClick={onClickHandler}
    >
      {children}
    </div>
  );
}

export default MainContentOffset;
